import { axiosClient } from "../../api/api";

export const ApprovedRedeemRequestApi = async (panelListId: number, id: any) => {
  return axiosClient
    .post("/api/survey/approvedRedeemRequest", {
          panelListId, id
    })
    .then((response) => response.data);
};
